import { makeAutoObservable } from 'mobx';
import { authService } from '../services/authService';
import { LoginCredentials } from '../types/auth';
import { notifySignIn, notifySignOut } from '../utils/webViewBridge';

class AuthStore {
  isLoading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  setError(error: string | null) {
    this.error = error;
  }

  // Helper method to handle error extraction consistently
  private handleError(error: any, defaultMessage: string): string {
    return error?.response?.data?.error?.errors?.join?.('. ') || defaultMessage;
  }

  logout() {
    const emailSaved = localStorage.getItem('email');
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    // Notify React Native WebView about logout
    notifySignOut(emailSaved);
    // Redirect to home screen
    window.location.href = '/';
  }

  async signin(loginCredentials: LoginCredentials) {
    this.setLoading(true);
    this.setError(null);

    const { remember, ...loginData } = loginCredentials;

    try {
      const { data } = await authService.login(loginData as LoginCredentials);
      localStorage.setItem('token', data.token);
      localStorage.setItem('email', data.email || '');
      this.setLoading(false);

      // Notify React Native WebView about successful login
      if (data.email && data.token) {
        notifySignIn(data.email, data.token);
      }

      return true;
    } catch (error: any) {
      this.setLoading(false);
      const errorMessage = this.handleError(error, 'Đăng nhập thất bại');
      this.setError(errorMessage);
      return false;
    }
  }

  async sendOtpResetPassword(data: { email?: string, phoneNumber?: string }, turnstileToken?: string) {
    try {
      await authService.sendOtpResetPassword(data, turnstileToken);
      return true;
    } catch (error: any) {
      this.setLoading(false);
      const errorMessage = this.handleError(error, 'Gửi OTP thất bại');
      this.setError(errorMessage);
      return false
    }
  }

  async verifyOtpResetPassword(payload: { otp: string, email?: string, phoneNumber?: string }) {
    try {
      const data = await authService.verifyOtpResetPassword(payload);
      return data?.data?.data?.token;
    } catch (error: any) {
      this.setLoading(false);
      const errorMessage = this.handleError(error, 'Xác thực OTP thất bại');
      this.setError(errorMessage);
      return false
    }
  }

  async resetPassword(payload: { phoneNumber?: string, email?: string, password: string, token: string }) {
    try {
      const data = await authService.resetPassword(payload);
      localStorage.setItem('token', data?.data?.data?.token);
      return true;
    } catch (error: any) {
      this.setLoading(false);
      const errorMessage = this.handleError(error, 'Đặt lại mật khẩu thất bại');
      this.setError(errorMessage);
      return false
    }
  }
}

export const authStore = new AuthStore();